import React from "react";
import { createPortal } from "react-dom";
import { Shield, Globe } from "lucide-react";

/**
 * Mode Selection Modal Component
 * Modal for choosing between Web Mode and Generate Script Mode
 */
export const ModeSelectionModal = ({
  isOpen,
  selectedColumnsCount,
  onWebModeClick,
  onScriptModeClick,
  onClose,
}) => {
  if (!isOpen) return null;

  return createPortal(
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-[999999]"
        onClick={onClose}
      />
      <div className="fixed inset-0 flex items-center justify-center z-[999999] p-4 pointer-events-none">
        <div
          className="bg-white rounded-2xl shadow-2xl w-full max-w-md pointer-events-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="px-6 py-5 border-b border-gray-200 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Shield className="w-6 h-6 text-purple-600" />
              <div>
                <h3 className="text-lg font-semibold text-gray-800">
                  Choose Protection Mode
                </h3>
                <p className="text-sm text-gray-500">
                  {selectedColumnsCount} column
                  {selectedColumnsCount > 1 ? "s" : ""} selected
                </p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="p-6 grid grid-cols-2 gap-4">
            <button
              onClick={onWebModeClick}
              className="flex flex-col items-center gap-3 p-6 border-2 border-gray-200 rounded-xl hover:border-purple-400 hover:bg-purple-50 transition-all group"
            >
              <div className="w-12 h-12 bg-purple-100 group-hover:bg-purple-200 rounded-full flex items-center justify-center transition-colors">
                <Globe className="w-6 h-6 text-purple-600" />
              </div>
              <div className="text-center">
                <p className="text-sm font-semibold text-gray-800">Web Mode</p>
                <p className="text-xs text-gray-500 mt-1">
                  Apply protection directly via the web interface
                </p>
              </div>
            </button>

            <button
              onClick={onScriptModeClick}
              className="flex flex-col items-center gap-3 p-6 border-2 border-gray-200 rounded-xl hover:border-purple-400 hover:bg-purple-50 transition-all group"
            >
              <div className="w-12 h-12 bg-purple-100 group-hover:bg-purple-200 rounded-full flex items-center justify-center transition-colors">
                <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                </svg>
              </div>
              <div className="text-center">
                <p className="text-sm font-semibold text-gray-800">
                  Generate Script
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  Download a script for your database platform
                </p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </>,
    document.body,
  );
};
